export default __webpack_public_path__ + "static/media/icon-chat.f3fdea5e.svg";